module.exports = __webpack_public_path__ + "img/1.902b93ad.png";